import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import React, { useContext, useEffect, useState } from 'react'

import colorContext from '../../Context/colorContext'
import {
  getAddress,
  getIcons,
  getLogos,
  getMenus,
} from '../../services/noticias'
import { handleFilter } from '../../utils/handleFilter'
import { PropsIconsHeader, PropsLogos } from '../Header'
import { useStyles } from './styles'

interface PropsAddress {
  bairro: string
  cep: string
  cidade: string
  link_localizacao: string
  local: string
  numero: string
  rua: string
  telefone: string
}

interface PropsSubMenu {
  icone: string
  id: string
  link: string
  slug: string
  titulo: string
  link_externo: boolean
  pagina_slug: string
  pagina_publicado: boolean
}

interface PropsMenu {
  titulo: string
  url: string
  isExternal: boolean
  pagina_publicado: boolean
  pagina_slug: string
  slug: string
}

interface PropsFooterMenu {
  titulo: string
  links: PropsMenu[]
}

export default function Footer(): JSX.Element {
  const { colors } = useContext(colorContext)
  const classes = useStyles({ colors })
  const [address, setAddress] = useState<PropsAddress>()
  const [logoFooter, setLogoFooter] = useState<PropsLogos>()
  const [iconsFooter, setIconsFooter] = useState<PropsIconsHeader[]>()
  const [footerMenus, setFooterMenus] = useState<PropsFooterMenu[]>([])

  useEffect(() => {
    async function handleAddress() {
      const { data } = await getAddress()

      setAddress(data[0])
    }

    handleAddress()
  }, [])

  useEffect(() => {
    async function handleIconsFooter() {
      const { data } = await getIcons()
      setIconsFooter(data)
    }

    handleIconsFooter()
  }, [])

  useEffect(() => {
    async function handleGetLogos() {
      try {
        const { data } = await getLogos()
        const resultFiltred = handleFilter(data, 'Rodapé')

        setLogoFooter(resultFiltred[0])
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    }

    handleGetLogos()
  }, [])

  const handleFormatLinksMenu = (menuData: PropsSubMenu[]) =>
    menuData.map((menu) => ({
      titulo: menu.titulo,
      url: menu.link,
      isExternal: menu.link_externo,
      pagina_publicado: menu.pagina_publicado || (menu?.link && true),
      pagina_slug: menu.pagina_slug,
      slug: menu.slug,
    }))

  useEffect(() => {
    async function handleGetFooterMenus() {
      try {
        const { data } = await getMenus('Rodapé')
        if (data?.results) {
          const menus: PropsFooterMenu[] = data.results.map((menu: any) => ({
            titulo: menu.titulo,
            links: menu.submenu_menu
              ? handleFormatLinksMenu(menu.submenu_menu)
              : [],
          }))

          const orderedMenus = menus.sort((a, b) => {
            const order = ['Governo', 'Imprensa', 'Atendimento']
            const indexA = order.indexOf(a.titulo)
            const indexB = order.indexOf(b.titulo)

            if (indexA !== -1 && indexB !== -1) {
              return indexA - indexB
            }
            if (indexA !== -1) return -1
            if (indexB !== -1) return 1
            return 0
          })

          setFooterMenus(orderedMenus)
        }
      } catch (error) {
        console.log(error)
      }
    }

    handleGetFooterMenus()
  }, [])

  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1440px" width="100%" flexDirection="column">
        <Box className={classes.boxFooter}>
          <Box className={classes.logoBoxAndInfos}>
            {logoFooter && (
              <a
                href={logoFooter.url || '/'}
                aria-label={
                  logoFooter.titulo
                    ? `Abrir site: ${logoFooter.titulo}`
                    : 'Abrir página do logotipo do rodapé'
                }
              >
                <img
                  alt={logoFooter.titulo}
                  width="313px"
                  height="100px"
                  style={{ width: '313px', height: '100px', marginBottom: 20 }}
                  src={logoFooter.url_imagem}
                  className={classes.img}
                  loading="lazy"
                />
              </a>
            )}

            {address && (
              <>
                <Typography className={classes.infoTextTitle}>
                  {address.local}
                </Typography>
                <Typography className={classes.infoTextSubTitle}>
                  {`${address?.rua}, ${address?.numero} - ${address?.bairro},`}
                  <br />
                  {`${address?.cidade} | CEP: ${address?.cep} `}
                  {address?.telefone && `| Telefone: ${address?.telefone}`}
                  <br />
                  {address?.link_localizacao && (
                    <a
                      className={classes.link}
                      href={address.link_localizacao}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {`Ver localização de ${address.local} no mapa`}
                    </a>
                  )}
                </Typography>
              </>
            )}

            {iconsFooter && (
              <Box className={classes.socials}>
                {iconsFooter.map((icon) => (
                  <IconButton
                    key={`${icon.titulo}-key`}
                    href={icon.url}
                    target="_blank"
                    aria-label={`${icon.titulo} (abre em nova aba)`}
                  >
                    <img
                      width="25px"
                      height="25px"
                      src={icon.url_imagem}
                      alt=""
                      loading="lazy"
                    />
                  </IconButton>
                ))}
              </Box>
            )}
          </Box>

          <Box className={classes.navFooter}>
            {footerMenus.map((menu, menuIndex) => (
              <Box key={menuIndex} className={classes.linkBox}>
                <Typography component="p">{menu.titulo}</Typography>
                <ul>
                  {menu.links.length === 0 ? (
                    <li style={{ opacity: 0.5, fontStyle: 'italic' }}>
                      Nenhum link disponível
                    </li>
                  ) : (
                    menu.links.map((item, index) => {
                      const hasLink = item.url || item.pagina_slug
                      const url =
                        item.url ||
                        (item.pagina_slug
                          ? `${process.env.PUBLIC_URL}/pagina/${item.pagina_slug}`
                          : null)

                      return (
                        <li key={index} style={{ opacity: hasLink ? 1 : 0.5 }}>
                          {hasLink ? (
                            item.isExternal ? (
                              <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item.titulo}
                              </a>
                            ) : (
                              <a href={url}>{item.titulo}</a>
                            )
                          ) : (
                            <span style={{ cursor: 'default' }}>
                              {item.titulo}
                            </span>
                          )}
                        </li>
                      )
                    })
                  )}
                </ul>
              </Box>
            ))}
          </Box>

          <Box className={classes.proderjBox}>
            <img
              width="153px"
              height="54px"
              src={`${process.env.PUBLIC_URL}/assets/images/webp/proderj_footer.webp`}
              alt="proderj"
              loading="lazy"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
